// Zeiterfassungs-Domaene (TIMEREC/GORS/SHF/U) - headless, kein DOM, keine
// Dialoge. Extrahiert aus CMP_CTimeRecord.js (Plan sharded-hatching-clover,
// Phase 3.3): der Screen und CLS_CSessionHandler.js rufen diese Funktionen,
// die UI-Entscheidungen (Dialoge, Session schliessen) bleiben
// dort.
//
// WICHTIG (Routing-Freeze): das Master/Slave-Routing in CLS_CSQLite.js
// haengt an sql.indexOf(" TIMEREC ") - die SQL-Formen hier sind deshalb
// ZEICHENGENAU aus dem Original uebernommen (inkl. Leerzeichen und
// NULL-Literale). Der Routing-Freeze-Check der Suite verifiziert das.
//
// Rueckgaben sind NATIVE Promises. Legacy-Aufrufer duerfen sie NICHT in
// $.when() stecken (jQuery 2.1.4 adoptiert fremde Thenables nicht!) -
// stattdessen .then() direkt, oder am Rand in ein jQuery-Deferred
// umfuellen (so machen es die Screen-Methoden).

function sql(query) {
  // POS.SQLiteCon liefert ein jQuery-Deferred-Promise; Promise.resolve()
  // adoptiert es sauber zu einer nativen Promise (die Gegenrichtung waere
  // die Falle, nicht diese).
  return Promise.resolve(POS.SQLiteCon.execute(query));
}

// Formt einen Wert exakt wie die historischen SQL-Strings: null -> NULL,
// String -> '...' (unveraendert, kein neues Escaping - Werte kommen aus
// GORS/SHF-Stammdaten), Zahl -> Zahl.
function lit(v) {
  if (v === null || v === undefined) return 'NULL';
  if (typeof v === 'number') return String(v);
  return "'" + v + "'";
}

export const TimeRecordDomain = {
  // Unix-Timestamp (Sekunden) von heute 00:00 lokal - Tagesgrenze der Anzeige.
  todayZeroTimestamp() {
    const d = new Date();
    const zero = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
    return (zero / 1000).toFixed(0);
  },

  // U.Login ist der Schluessel, unter dem TIMEREC schreibt (nicht U_ID!).
  getLoginId(userId) {
    return sql('SELECT Login FROM U WHERE U_ID = ' + userId)
      .then((rows) => rows[0].Login);
  },

  // Heutige Eintraege, neueste zuerst (Anzeige-Tabelle des Screens).
  getEntriesSince(loginId, minTimestamp) {
    return sql('SELECT TS, Event, Reason, Shift, ExtraHours FROM TIMEREC ' +
      ' WHERE U_ID = ' + loginId + ' AND TS > ' + minTimestamp +
      ' ORDER BY TR_ID DESC');
  },

  // Juengster Eintrag (Pause-Erkennung) - null wenn keiner existiert.
  getLastEntry(loginId) {
    return sql('SELECT TR_ID, TS, Event, Reason FROM TIMEREC WHERE U_ID = ' + loginId +
      ' ORDER BY TR_ID DESC LIMIT 1')
      .then((rows) => (rows && rows.length ? rows[0] : null));
  },

  // Juengste Kommzeit (fuer die einmal-pro-Tag-Pruefung).
  getLastComeTime(loginId) {
    return sql("SELECT TS FROM TIMEREC WHERE U_ID = " + loginId +
      " AND Event = 'KOM' ORDER BY TR_ID DESC LIMIT 1")
      .then((rows) => (rows && rows.length ? rows[0].TS : null));
  },

  getReasons() { return sql('SELECT Reason FROM GORS'); },
  getShifts() { return sql('SELECT Shift FROM SHF'); },

  // Ein Kommen/Gehen-Ereignis buchen. ts in Sekunden (String oder Zahl);
  // reason/shift null -> NULL, extraHours null -> NULL sonst Zahl.
  insertEvent(loginId, ts, event, reason, shift, extraHours) {
    return sql('INSERT INTO TIMEREC (U_ID, TS, Event, Reason, Shift, ExtraHours) ' +
      'VALUES ( ' + loginId + ', ' + ts + ", '" + event + "', " +
      lit(reason) + ', ' + lit(shift) + ', ' + lit(extraHours) + ')');
  },

  deleteEntry(trId) {
    return sql('DELETE FROM TIMEREC WHERE TR_ID = ' + trId);
  },
};
